import React from 'react';
import '../css/MissionVisionStatements.css';

const MissionVisionStatements = () => {
  return (
    <section className="gfi-mv-statements-section">
      <div className="gfi-mv-statements-container">
        
        <div className="gfi-mv-statements-grid">
          
          {/* LEFT BLOCK: OUR MISSION CARD (Blue Top Accent Strip) */}
          <div className="gfi-mv-statement-card gfi-mv-accent-blue">
            
            {/* Target Core Vector Icon Frame */}
            <div className="gfi-mv-card-icon-wrapper">
              <span className="gfi-mv-vector-symbol">🎯</span>
            </div>

            <h2 className="gfi-mv-card-title">Our Mission</h2>
            
            <div className="gfi-mv-card-body-text">
              <p>
                Our mission is to provide high-quality, practical, and career-oriented Fire & Safety 
                and Industrial Safety education that supports professional growth, workplace safety awareness, 
                and employability.
              </p>
              <p className="gfi-mv-secondary-para">
                We aim to create skilled safety professionals capable of contributing to safer workplaces 
                and responsible industrial practices.
              </p>
            </div>

          </div>

          {/* RIGHT BLOCK: OUR VISION CARD (Dark Indigo Top Accent Strip) */}
          <div className="gfi-mv-statement-card gfi-mv-accent-dark">
            
            {/* Vision Eye Vector Icon Frame */}
            <div className="gfi-mv-card-icon-wrapper">
              <span className="gfi-mv-vector-symbol">👁️</span>
            </div>

            <h2 className="gfi-mv-card-title">Our Vision</h2>
            
            <div className="gfi-mv-card-body-text">
              <p>
                Our vision is to become a trusted and recognized training institute for Fire & Safety, 
                Industrial Safety, NEBOSH, IOSH, and HSE education across India through quality learning, 
                professional standards, and student success.
              </p>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default MissionVisionStatements;